<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" :model="conditions">
        <el-form-item>
          <el-input v-model="conditions.couponName" placeholder="优惠券名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="conditions.status" placeholder="状态" clearable style="width:120px">
            <el-option label="上架" value="ON" />
            <el-option label="下架" value="OFF" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_query">查询</el-button>
          <el-button @click="_reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>商城优惠券</span>
        <el-button type="primary" size="small" @click="_openDialog()">新建优惠券</el-button>
      </div>
      <el-table :data="list" border stripe>
        <el-table-column prop="couponName" label="名称" align="center" min-width="120" />
        <el-table-column label="类型" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.couponType === '2002' ? '分类券' : '全场券' }}
          </template>
        </el-table-column>
        <el-table-column label="满减" align="center" width="120">
          <template slot-scope="scope">
            满{{ scope.row.minAmount }}减{{ scope.row.discountAmount }}
          </template>
        </el-table-column>
        <el-table-column label="领取/总量" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.receivedCount }}/{{ scope.row.totalCount == null || scope.row.totalCount === '' ? '不限' : scope.row.totalCount }}
          </template>
        </el-table-column>
        <el-table-column prop="perUserLimit" label="每人限领" align="center" width="90" />
        <el-table-column label="有效期" align="center" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column label="可见小区" align="center" min-width="120">
          <template slot-scope="scope">
            {{ formatCommunities(scope.row.communities) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'ON' ? 'success' : 'info'" size="small">
              {{ scope.row.status === 'ON' ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openDialog(scope.row)">编辑</el-button>
            <el-button
              v-if="scope.row.status === 'ON'"
              size="mini"
              type="warning"
              @click="_toggleStatus(scope.row, 'OFF')"
            >下架</el-button>
            <el-button
              v-else
              size="mini"
              type="success"
              @click="_toggleStatus(scope.row, 'ON')"
            >上架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:16px"
        :current-page="conditions.page"
        :page-size="conditions.row"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="_pageChange"
      />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" @close="_resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="优惠券名称" prop="couponName">
          <el-input v-model="form.couponName" />
        </el-form-item>
        <el-form-item label="券类型" prop="couponType">
          <el-radio-group v-model="form.couponType">
            <el-radio label="1001">全场通用</el-radio>
            <el-radio label="2002">分类商品券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.couponType === '2002'" label="商品分组" prop="categoryId">
          <el-select v-model="form.categoryId" placeholder="必填，请选择顶级商品分组" style="width:100%">
            <el-option label="必填，请选择顶级商品分组" value="" disabled />
            <el-option
              v-for="(item, index) in categories"
              :key="index"
              :label="item.categoryName"
              :value="item.categoryId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="满减门槛" prop="minAmount">
          <el-input v-model="form.minAmount" placeholder="满多少元">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="减免金额" prop="discountAmount">
          <el-input v-model="form.discountAmount" placeholder="减多少元">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="发放总量">
          <el-input v-model="form.totalCount" placeholder="留空表示不限" />
        </el-form-item>
        <el-form-item label="每人限领" prop="perUserLimit">
          <el-input-number v-model="form.perUserLimit" :min="1" />
        </el-form-item>
        <el-form-item label="有效期" prop="timeRange">
          <el-date-picker
            v-model="form.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="可见小区">
          <el-select
            v-model="form.communityIds"
            multiple
            filterable
            placeholder="不选表示全部小区可见"
            style="width:100%"
          >
            <el-option
              v-for="item in communityList"
              :key="item.communityId"
              :label="item.name"
              :value="item.communityId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="使用说明">
          <el-input v-model="form.remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="_submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMallCoupon,
  saveMallCoupon,
  updateMallCoupon,
  updateMallCouponStatus
} from '@/api/market/mallCouponApi'
import { queryProductCategory } from '@/api/goods/productApi'
import { getMallCommunityList } from '@/api/shop/mallCommunityApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'MallCouponManage',
  data() {
    return {
      list: [],
      total: 0,
      categories: [],
      communityList: [],
      conditions: { couponName: '', status: '', shopId: '', page: 1, row: 10 },
      dialogVisible: false,
      dialogTitle: '新建优惠券',
      form: this._emptyForm(),
      rules: {
        couponName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        couponType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        categoryId: [{
          validator: (rule, value, callback) => {
            if (this.form.couponType === '2002' && !value) {
              callback(new Error('请选择顶级商品分组'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        minAmount: [{ required: true, message: '请输入门槛', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value === '' || value == null || isNaN(Number(value)) || Number(value) <= 0) {
              callback(new Error('门槛须为正数'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        discountAmount: [{ required: true, message: '请输入减免金额', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value === '' || value == null || isNaN(Number(value)) || Number(value) <= 0) {
              callback(new Error('减免金额须为正数'))
            } else if (this.form.minAmount && Number(value) > Number(this.form.minAmount)) {
              callback(new Error('减免金额不能大于门槛'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        perUserLimit: [{ required: true, message: '请输入限领', trigger: 'blur' }],
        timeRange: [{ required: true, message: '请选择有效期', trigger: 'change' }]
      }
    }
  },
  created() {
    this._init()
  },
  methods: {
    _emptyForm() {
      return {
        couponId: '',
        shopId: '',
        couponName: '',
        couponType: '1001',
        categoryId: '',
        minAmount: '',
        discountAmount: '',
        totalCount: '',
        perUserLimit: 1,
        timeRange: [],
        communityIds: [],
        remark: '',
        status: 'ON'
      }
    },
    async _init() {
      this.conditions.shopId = await getShopId()
      await this._loadCategories()
      await this._loadCommunities()
      this._query()
    },
    async _loadCategories() {
      try {
        const params = {
          page: 1,
          row: 200,
          shopId: getShopId(),
          categoryLevel: '1'
        }
        const res = await queryProductCategory(params)
        this.categories = res.data || []
      } catch (error) {
        console.error('获取顶级商品分组失败:', error)
        this.categories = []
      }
    },
    async _loadCommunities() {
      try {
        const res = await getMallCommunityList({ page: 1, row: 500 })
        if (res.code !== 0) {
          this.$message.error(res.msg || '加载小区列表失败')
          return
        }
        this.communityList = res.data || []
      } catch (e) {
        this.$message.error('加载小区列表失败')
      }
    },
    formatCommunities(communities) {
      if (!communities || !communities.length) return '全部小区'
      return communities.map(c => c.communityName || c.communityId).join('、')
    },
    async _query() {
      this.conditions.shopId = await getShopId()
      const res = await listMallCoupon(this.conditions)
      this.list = res.data || []
      this.total = res.total || 0
    },
    _reset() {
      this.conditions.couponName = ''
      this.conditions.status = ''
      this.conditions.page = 1
      this._query()
    },
    _pageChange(page) {
      this.conditions.page = page
      this._query()
    },
    _openDialog(row) {
      if (row) {
        this.dialogTitle = '编辑优惠券'
        this.form = {
          couponId: row.couponId,
          shopId: row.shopId,
          couponName: row.couponName,
          couponType: row.couponType,
          categoryId: row.categoryId || '',
          minAmount: row.minAmount,
          discountAmount: row.discountAmount,
          totalCount: row.totalCount || '',
          perUserLimit: parseInt(row.perUserLimit || 1, 10),
          timeRange: [row.startTime, row.endTime],
          communityIds: (row.communities || []).map(c => c.communityId),
          remark: row.remark || '',
          status: row.status
        }
      } else {
        this.dialogTitle = '新建优惠券'
        this.form = this._emptyForm()
        this.form.shopId = this.conditions.shopId
      }
      this._loadCategories()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    _resetForm() {
      this.form = this._emptyForm()
    },
    _buildPayload() {
      const payload = {
        ...this.form,
        shopId: this.conditions.shopId,
        startTime: this.form.timeRange[0],
        endTime: this.form.timeRange[1],
        communityIds: this.form.communityIds.map(id => {
          const c = this.communityList.find(x => x.communityId === id)
          return { communityId: id, communityName: c ? c.name : '' }
        })
      }
      if (!payload.totalCount) delete payload.totalCount
      if (payload.couponType !== '2002') payload.categoryId = ''
      return payload
    },
    _submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (this.form.couponType === '2002' && !this.form.categoryId) {
          this.$message.warning('请选择顶级商品分组')
          return
        }
        try {
          const payload = this._buildPayload()
          if (this.form.couponId) {
            await updateMallCoupon(payload)
          } else {
            await saveMallCoupon(payload)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this._query()
        } catch (e) {
          this.$message.error(typeof e === 'string' ? e : '保存失败')
        }
      })
    },
    async _toggleStatus(row, status) {
      try {
        await updateMallCouponStatus({
          couponId: row.couponId,
          shopId: row.shopId,
          status
        })
        this.$message.success('操作成功')
        this._query()
      } catch (e) {
        this.$message.error(typeof e === 'string' ? e : (e && e.message) || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 10px;
}
</style>
